export default {
  label: 'CPF',
  hint: 'O seu banco precisa do seu CPF para este pagamento. Nós transmitimo-lo e não o guardamos.',
  invalid: 'Este não é um CPF válido. Verifique os 11 dígitos.',
};
